var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticStyle:{"color":"#CCC"}},[_c('b-tooltip',{attrs:{"type":"is-light","multilined":"","label":_vm.title}},[_c('i',{staticClass:"fas fa-question-circle"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }